import { MegaMenu } from './mega-menu';
import Sidenav from './side-nav';

export default function initMainNavigation(): void {
    const menu = document.querySelector( '.siteheader' ) as HTMLElement | null;

    if ( menu ) {
        window.megaMenu = new MegaMenu( menu );
    }

    const sidenav = document.querySelector( '.sidenav' ) as HTMLElement | null;

    if ( sidenav ) {
        window.sidenav = new Sidenav( sidenav );
    }
}
